//== ApexCharts Utils for setting configuration and options
import * as LanguageUtils from  "./LanguageUtils";

var fr = require("apexcharts/dist/locales/fr.json");
var en = require("apexcharts/dist/locales/en.json");
var it = require("apexcharts/dist/locales/it.json");
var zh = require("apexcharts/dist/locales/zh-tw.json");

export const getDefaultLocale = (intl) => {
    let lang = intl.locale.toLocaleLowerCase();
    let localeKeysList = LanguageUtils.getAvailableLanguageCodes();
    const found = localeKeysList.map(e => e.toLocaleLowerCase()).includes(lang); 
    return found ? lang : "en"
}

export const getAvailableLanguageCodes = () => {
    return [fr, en, it, zh];
}